import React, { Component } from 'react';
import { NavLink } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import PropTypes from 'prop-types';
import {createSelector} from "reselect";
import { connect } from "react-redux";
import LoggedUser from './LoggedUser';
import { DocumentTitle, Role } from '../../../helpers';
import { AppBar, CssBaseline, useScrollTrigger, Slide } from '@material-ui/core';
import { defaultActions } from '../../../common/redux/actions';
//import { defaultActions } from '../../../common/redux/actions';

function HideOnScroll(props) {
    const { children, window } = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({ target: window ? window() : undefined });
  
    return (
      <Slide appear={false} direction="down" in={!trigger}>
        {children}
      </Slide>
    );
  }
  
  HideOnScroll.propTypes = {
    children: PropTypes.element.isRequired,
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
  };

class Header extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loggedIn: props.authentication.loggedIn,
            authentication: props.authentication,
        }
    }

    componentDidMount() {
        const { dispatch, categories } = this.props;
        Object.getOwnPropertyNames(categories).length === 0 && dispatch(defaultActions.categories()); // {parent_id: 1}
    }

    render() {
        //console.log('pages', this.props)
        const { loggedIn } = this.state;
        const { authentication } = this.props;
        const user = authentication && authentication.authentication && authentication.authentication.user;

        return (<React.Fragment>
            <CssBaseline />
            <HideOnScroll {...this.props}>
                <AppBar position="fixed" id="header">                
                    <DocumentTitle title={`Home`}/>
                    <Navbar bg="dark" expand="lg" variant="dark">
                        <div className="container">
                            <NavLink className="navbar-brand" to="/">
                                <img src="/images/svg/Logo-new.svg" alt="Logo" className="img-fluid" />
                            </NavLink>
                            <Navbar.Toggle aria-controls="basic-navbar-nav" />
                            <Navbar.Collapse id="basic-navbar-nav" className="">
                                <Nav className="navbar-nav navbar-main ml-auto" as="ul">
                                    
                                    <Nav.Item as="li" className={(user && user.role === Role.Tutor) ? 'd-none' : '' }>
                                        <NavLink className="nav-link" to="/search-tutors">Find a Tutor</NavLink>
                                    </Nav.Item>
                                    {/*<Nav.Item as="li">
                                        <NavLink className="nav-link" to="/subject"> Subject </NavLink>
                                    </Nav.Item>*/}
                                    {!loggedIn && <>
                                        <Nav.Item as="li">
                                            <NavLink className="nav-link" to="/register"> Sign Up </NavLink>
                                        </Nav.Item>
                                        <Nav.Item as="li">
                                            <NavLink className="nav-link" to="/login"> Log In </NavLink>
                                        </Nav.Item>
                                    </>}
                                </Nav>
                            </Navbar.Collapse>

                            {!loggedIn && <>
                                <ul className="navbar-nav navbar-login">
                                    <li className="nav-item ml-3">
                                        <NavLink activeClassName="active" className="nav-link btn-secondary text-white font-weight-bold rounded" to="/tutor">Become a Tutor</NavLink>
                                    </li>
                                </ul>
                            </>}
                            
                            {loggedIn && <LoggedUser /> }
                        </div>
                    </Navbar>
                </AppBar>
            </HideOnScroll>
        </React.Fragment>);
    }
}


const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const pagesSelector = createSelector(
    state => state.pages,
    pages => pages
);

const categoriesSelector = createSelector(
    state => state.categories,
    categories => categories
);

const mapStateToProps = createSelector(
    authenticationSelector,
    pagesSelector,
    categoriesSelector,
    (authentication, pages, categories) => ({
        authentication, pages, categories
    })
);

export default connect(mapStateToProps)(Header);



